import { render } from "./report-suggestions.vue?vue&type=template&id=4732cfe9"
import script from "./report-suggestions.vue?vue&type=script&lang=js"
export * from "./report-suggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__